export const WE_ARE_PREPARING_YOUR_ORDER_TRANSLATION_ID = 'weArePreparingYourOrder';
